module.exports = __webpack_public_path__ + "static/media/texture (21).55e7dbd4.jpg";